import { useMemo } from 'react';
import { useWeb3React } from '@web3-react/core';
import { ethers } from 'ethers';

const useContract = (address, abi) => {
  const { library, account, chainId } = useWeb3React();

  return useMemo(() => {
    if (!abi || !address || !library || !account || !chainId) {
      return null;
    } else {
      return new ethers.Contract(address, abi, library.getSigner());
    }
  }, [address, abi, library, account, chainId]);
};

export default useContract;
